import type {CSSProperties} from 'react';
import {WEDGE_TESTER_OPS} from '@territory/tokens';
import {font, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeTesterOpsLook = 'tester-approve' | 'tester-nudge' | 'tester-nudge-on';

const TESTER_OPS_LOOKS = new Set<string>(['tester-approve', 'tester-nudge', 'tester-nudge-on']);
export const isWedgeTesterOpsLook = (look: string): look is WedgeTesterOpsLook => TESTER_OPS_LOOKS.has(look);

/* Released Tester Tools Pending approvals and Cold cohort cards (Settings, founder-testers only): two kinds of native control. Approve & send is a
   9px radius button with 7px by 12px padding, 12px bold type and no shrink in the row of a pending user; it takes the accent fill with the fixed
   white ink (WEDGE_TESTER_OPS.accentInk), and held (the caller sets `disabled` while the approval runs) the elevated fill with the secondary ink
   and the default cursor, not the wait cursor. Nudge is a 6px radius button with 4px by 8px padding and 10.5px bold uppercase type with a 0.4 track,
   in the row of a cold user: idle the elevated fill with the secondary ink, once copied (`tester-nudge-on`) the accent fill with the same white ink.
   The released Nudge sets no font family, so the look prints none. Each reads the exact legacy roles, and the declaration order is the order of
   the source. The caller owns the labels, the handlers and the layout. */
const APPROVE_PADDING = '7px 12px', APPROVE_RADIUS = 9;
const NUDGE_FONT = 10.5, NUDGE_TRACK = 0.4, NUDGE_PADDING = '4px 8px', NUDGE_RADIUS = 6;

export function wedgeTesterOpsStyle(look: WedgeTesterOpsLook, disabled = false): CSSProperties {
  const r = wedgeExactRole;
  if (look === 'tester-approve') return {
    flexShrink: 0, padding: APPROVE_PADDING, borderRadius: APPROVE_RADIUS, border: 0,
    background: disabled ? r('bgElev') : r('accent'), color: disabled ? r('labelSec') : WEDGE_TESTER_OPS.accentInk,
    fontSize: font.caption, fontWeight: weight.bold, fontFamily: r('font'), cursor: disabled ? 'default' : 'pointer',
  };
  const on = look === 'tester-nudge-on';
  return {
    fontSize: NUDGE_FONT, fontWeight: weight.bold, letterSpacing: NUDGE_TRACK, textTransform: 'uppercase',
    padding: NUDGE_PADDING, borderRadius: NUDGE_RADIUS, border: 0, cursor: 'pointer',
    background: on ? r('accent') : r('bgElev'), color: on ? WEDGE_TESTER_OPS.accentInk : r('labelSec'), flexShrink: 0,
  };
}
